import { apiCallPost } from "../api"
import { apiPaths } from "../config/apiPaths";

export const complaintStatusAndPriorityApi = async (locale, authHeaders) => {
    const inputData = { locale };
    return await apiCallPost(apiPaths.statusAndPriority, inputData, authHeaders);
};
